import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/products/headerRightBg.png';
import headerRightBg375 from '../images/products/headerRightBg375.png';
import JigsawManWoman from '../images/products/jigsawManWoman.svg';

import EmailContactSales from '../components/EmailContactSales';
import ProductBox from '../components/ProductBox';
import radialGradient from '../images/radialShadow.jpg';
import DashboardIconComponent from '../images/products/DashboardIconComponent.jsx';
import CoreConnectIconComponent from '../images/products/CoreConnectIconComponent.jsx';
import DecisionTimeIconComponent from '../images/products/DecisionTimeIconComponent.jsx';
import CreditConnectIconComponent from '../images/products/CreditConnectIconComponent.jsx';
import FraudTrackIconComponent from '../images/products/FraudTrackIconComponent.jsx';
import AppShieldIconComponent from '../images/products/AppShieldIconComponent.jsx';
import SalesFunnelIconComponent from '../images/products/SalesFunnelIconComponent.jsx';
import AppFlowIconComponent from '../images/products/AppFlowIconComponent.jsx';
import SecureSignIconComponent from '../images/products/SecureSignIconComponent.jsx';
import SecureTransferIconComponent from '../images/products/SecureTransferIconComponent.jsx';
import DocumentsIconComponent from '../images/products/DocumentsIconComponent.jsx';
import MessagingIconComponent from '../images/products/MessagingIconComponent.jsx';

const HeaderTopContent = styled.article`
	p {
		margin-bottom: 0;
	}
	@media (${(props) => props.theme.mediumUp}) {
		max-width: 470px;
	}
}
`;

const headerContent = (
	<HeaderTopContent style={{ marginTop: `0`, marginBottom: `2em` }}>
		<h1>The complete<br />lending platform</h1>
		<p>Streamline loan originations, prevent fraud, and attract customers with MK's intelligent and expansive product suite.</p>
		<EmailContactSales />
	</HeaderTopContent>
);

const HeaderBottomContentFigure = styled.figure`
	margin-bottom: 2em;

	@media (${(props) => props.theme.mediumUp}) {
		margin-bottom: 3em;
	}
}
`;

const headerFigure = (
	<HeaderBottomContentFigure>
		<JigsawManWoman alt='Man and woman building a jigsaw puzzle' />
	</HeaderBottomContentFigure>
);

const Wrapper = styled.div`
	padding-bottom: 3em;
`;

const RadialGradient = styled.div`
@media (${(props) => props.theme.mediumUp}) {
	background-image: ${(props) => `url('${radialGradient}')`};
	background-size: 100% 100%;
	background-position: center center;
	max-width: 1366px;
	margin-left: auto;
	margin-right: auto;
	padding: 0;
}
`;

const Section = styled.section`
	border: none;

	&.product-boxes {
		margin-top: -3em;

		@media (${(props) => props.theme.xLargeUp}) {
			padding-left: 8.5%;
			padding-right: 8.5%;
		}
	}
`;

class ProductsPage extends React.Component {
	render() {
		return (
			<Layout
				headerSplashBg375={headerRightBg375}
				headerSplashBgSize={'100% 100%'}
				headerSplashBgPosition={'center top'}

				headerSplashBg={headerRightBg}
				headerSplashBgSizeLarge={'auto'}
				headerSplashBgPositionLarge={'center top'}
				headerSplashAlignItemsLarge={'flex-end'}
				headerBottomContent={headerFigure}
				headerContentClass={'product'}
				headerContent={headerContent}
				headerSplashBgAverageColor={'white'}
				metaDescription={"MK Decision's platform includes streamlined products to make lending simple for financial institutions and lenders."}
				pageTitle='Complete Lending Platform | Suite of Technology Solutions for Lenders'
				skipMoney2020={true}
				skipUseCases={true}
				headerContentMaxWidth={'500px'}
				splashHeaderMinHeight={'480px'}
				BodyClass={'viewAllProducts'}
			>
				<Wrapper className='centeredWrapper'>
					<RadialGradient>
						<Section className='product-boxes row row-flush'>
							<ProductBox
								product = {'Dashboard'}
								productLink = {'/Dashboard/'}
								productOneLiner = {'Empower underwriters to multitask and process more loans'}
								icon = {<DashboardIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'CoreConnect'}
								productLink = {'/CoreConnect/'}
								productOneLiner = {'Integrate with core processors to automate data flow'}
								icon = {<CoreConnectIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'DecisionTime'}
								productLink = {'/DecisionTime/'}
								productOneLiner = {'Make credit decisions faster, whether automated or manual'}
								icon = {<DecisionTimeIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'CreditConnect'}
								productLink = {'/CreditConnect/'}
								productOneLiner = {'Integrate with credit bureaus for fast access to credit data'}
								icon = {<CreditConnectIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'FraudTrack'}
								productLink = {'/FraudTrack/'}
								productOneLiner = {'Manage risk with suspicious activity alerts'}
								icon = {<FraudTrackIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'AppShield'}
								productLink = {'/AppShield/'}
								productOneLiner = {'Save time by restricting prohibited applications'}
								icon = {<AppShieldIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'SalesFunnel'}
								productLink = {'/SalesFunnel/'}
								productOneLiner = {'Build brand recognition with modern marketing pages'}
								icon = {<SalesFunnelIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'AppFlow'}
								productLink = {'/AppFlow/'}
								productOneLiner = {'Provide easy, online applications for account creation'}
								icon = {<AppFlowIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'SecureSign'}
								productLink = {'/SecureSign/'}
								productOneLiner = {'Go green with user-friendly digital signatures'}
								icon = {<SecureSignIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'SecureTransfer'}
								productLink = {'/SecureTransfer/'}
								productOneLiner = {'Ensure data security with cost-effective file transfers'}
								icon = {<SecureTransferIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'Documents'}
								productLink = {'/Documents/'}
								productOneLiner = {'Dynamic document generation engine'}
								icon = {<DocumentsIconComponent diameter={'120'} />}
							/>
							<ProductBox
								product = {'Messaging'}
								productLink = {'/Messaging/'}
								productOneLiner = {'Real-time communication during the loan process'}
								icon = {<MessagingIconComponent diameter={'120'} />}
							/>
						</Section>
					</RadialGradient>
				</Wrapper>
			</Layout>
		);
	}
}

export default ProductsPage;
